import React from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Button,
  CircularProgress,
  Paper,
} from "@mui/material";

function truncateActivityPreview(text, maxLen) {
  if (typeof text !== "string" || !maxLen) return text;
  if (text.length <= maxLen) return text.slice(0, maxLen);
  return `${text.slice(0, maxLen)}…`;
}

function renderRecentActivityBody({
  loadingActivities,
  activities,
  selectedActivity,
  setSelectedActivity,
  MAX_DESC_LEN,
  getActivityText,
  renderHighlighted,
  formatRelativeTime,
  hasMoreActivities,
  loadMoreActivities,
}) {
  if (loadingActivities) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!activities?.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No recent activity.
      </Typography>
    );
  }

  return (
    <>
      <List dense disablePadding>
        {activities.map((item, idx) => {
          const key = item?.id ?? item?.activity_id ?? idx;
          const text = getActivityText?.(item) ?? "";
          const preview = truncateActivityPreview(text, MAX_DESC_LEN);
          return (
            <ListItemButton
              key={key}
              selected={selectedActivity === item}
              onClick={() => setSelectedActivity?.(item)}
              sx={{ borderRadius: 1, mb: 0.5 }}
            >
              <ListItemText
                primary={renderHighlighted ? renderHighlighted(preview) : preview}
                secondary={formatRelativeTime?.(item?.created_at ?? item?.timestamp)}
              />
            </ListItemButton>
          );
        })}
      </List>
      {hasMoreActivities && (
        <Button fullWidth sx={{ mt: 1 }} onClick={loadMoreActivities}>
          Load more
        </Button>
      )}
    </>
  );
}

export default function RecentActivitySection({
  loadingActivities,
  selectedActivity,
  setSelectedActivity,
  activities,
  MAX_DESC_LEN,
  getActivityText,
  renderHighlighted,
  formatRelativeTime,
  hasMoreActivities,
  loadMoreActivities,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 1 }}>
      <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 600 }}>
        Recent activity
      </Typography>
      {renderRecentActivityBody({
        loadingActivities,
        activities,
        selectedActivity,
        setSelectedActivity,
        MAX_DESC_LEN,
        getActivityText,
        renderHighlighted,
        formatRelativeTime,
        hasMoreActivities,
        loadMoreActivities,
      })}
    </Paper>
  );
}
